import React from 'react';
import { connect } from 'react-redux';

import {
  selectData,
  selectRequestState,
  setDefaultCaptchaType,
  setOnlyFailValidCounter,
  setAscCaptchaType,
  sendRequestGetCaptcha
} from 'mt-react-common/modules/main/reducers/static/states/captcha/reducer';

export default function createContainer(ChildContainer) {
  const DefaultCaptcha = props => <ChildContainer {...props} />;

  const mapStateToProps = state => ({
    requestState: selectRequestState(state),
    data: selectData(state)
  });

  const mapDispatchToProps = dispatch => ({
    setDefaultCaptchaType: () => dispatch(setDefaultCaptchaType()),
    setOnlyFailValidCounter: () => dispatch(setOnlyFailValidCounter()),
    setAscCaptchaType: () => dispatch(setAscCaptchaType()),
    sendRequestGetCaptcha: hasRegenerate =>
      dispatch(sendRequestGetCaptcha(hasRegenerate))
  });

  return connect(
    mapStateToProps,
    mapDispatchToProps
  )(DefaultCaptcha);
}



// WEBPACK FOOTER //
// ./src/components/Captcha/containers/CaptchaContainer/CaptchaContainer.js